export default __webpack_public_path__ + "static/media/Production_Team.8a0e1aa5.png";